import * as types from '../constants/actionTypes';
import initialState from './initialState';
// import _ from "lodash";
import findIndex from 'lodash.findindex';
import groupBy from 'lodash.groupby';
import filter from 'lodash.filter';
import concat from 'lodash.concat';
import reduce from 'lodash.reduce';
import unionBy from 'lodash.unionby';
import uniqBy from 'lodash.uniqby';
import sortBy from 'lodash.sortby';
import { CATEGORY_ID } from '../constants/category';

export default function editProfileReducer(state = initialState.editProfileState, action: any) {
  // console.log(action);
  switch (action.type) {
    case types.GET_GALLERIES_SUCCESS: {
      let { galleries } = state;
      const { userPhoto } = state;
      const { data } = action;
      const temp: any[] = [];
      if (data) {
        galleries = data;
        data.data.forEach((item: any) => {
          if (item.galleryId && item.galleryId !== 10007) {
            const i = {
              id: item.galleryId.toString(),
              data: [],
            };
            temp.push(i);
          }
        });
      }

      state = state.set('isLoadedGaleries', true);
      return state.merge({ galleries, isFetchingGallery: false, userPhoto: [...userPhoto, ...temp] });
    }
    case types.GET_GALLERIES_REQUEST: {
      return state.set('isFetchingGallery', true);
    }
    case types.GET_USER_PHOTO_REQUEST: {
      return state.set('isFetchingUserPhotos', true);
    }
    case types.RESET_USER_PHOTO: {
      const userPhoto = [
        {
          id: '10007',
          data: [],
        },
        {
          id: 'mainPhoto',
          data: [],
        },
      ];
      return state.merge({ userPhoto });
    }
    case types.GET_USER_PHOTO_SUCCESS: {
      let userPhoto = state.userPhoto.asMutable({ deep: true });
      const { data } = action;
      const publicData: any[] = [];
      const mainPhoto: any[] = [];
      const groups = groupBy(data, (item: any) => item.gallery.galleryId);
      const photoRejected = filter(data, (item: any) => item.approvalStatus === 'Rejected');
      const photoRestricted = filter(data, (item: any) => item.approvalStatus === 'Restricted');
      const hasPhotoRejected = photoRejected.length > 0;
      const hasPhotoRestricted = photoRestricted.length > 0;
      const dataReduce: any = reduce(
        groups,
        (result: any[], group: any, index: any) => {
          if (index === '10007') {
            group.forEach((item: any) => {
              if (item.mainPhoto) {
                mainPhoto.push(item);
              } else {
                publicData.push(item);
              }
            });
            if (publicData.length > 0) {
              result.push({
                id: index,
                data: publicData,
              });
            }
            if (mainPhoto.length > 0) {
              result.push({
                id: 'mainPhoto',
                data: mainPhoto,
              });
            }
          } else {
            result.push({
              id: index,
              data: group,
            });
          }

          return result;
        },
        []
      );
      if (dataReduce) {
        userPhoto = unionBy(dataReduce, userPhoto, 'id');
      }
      state = state.set('isLoadedUserPhotos', true);
      return state.merge({
        photoData: data,
        userPhoto,
        hasPhotoRejected,
        photoRejected,
        hasPhotoRestricted,
        photoRestricted,
        isFetchingUserPhotos: false,
      });
    }
    case types.GET_PROPERTY_PROFILE_BUILDER: {
      const { data, key } = action;
      const updateObj = {
        [key]: data,
      };
      return state.merge({ ...updateObj });
    }
    case types.GET_PROPERTY_SUCCESS: {
      const { data, key, userInfo } = action;
      let updateObj = {};
      const key2 = `${key}2`;
      const label = `${key}Label`;
      const label2 = `${key}Label2`;
      let labelValue = null;
      let label2Value = null;
      if (data) {
        if (userInfo) {
          if (userInfo[key] !== null || userInfo[key2] !== null) {
            const mapData: any[] = [];
            data.forEach((item: any) => {
              const i = { ...item };
              let value = 3;
              if (userInfo[key] !== userInfo[key2]) {
                value = i.id === userInfo[key2] ? 2 : 1;
              }
              i.active = false;
              i.value = null;
              if (i.id === userInfo[key] || i.id === userInfo[key2]) {
                i.active = true;
                i.value = value; // 2 her 1 him
                if (userInfo[key] === userInfo[key2]) {
                  labelValue = i.label;
                  label2Value = i.label;
                } else {
                  if (i.id === userInfo[key]) {
                    labelValue = i.label;
                  } else if (i.id === userInfo[key2]) {
                    label2Value = i.label;
                  }
                }
              }
              mapData.push(i);
            });
            updateObj = {
              [key]: mapData,
              [label]: labelValue,
              [label2]: label2Value,
            };
          } else {
            updateObj = {
              [key]: data,
              [label]: labelValue,
              [label2]: label2Value,
            };
          }
        } else {
          updateObj = {
            [key]: data,
            [label]: labelValue,
            [label2]: label2Value,
          };
        }
      }
      return state.merge({ ...updateObj });
    }
    case types.GET_INTEREST_PROPERTY_SUCCESS: {
      const { data, key, userInfo } = action;
      let merge = [];
      let sortList = [];
      let sort = [];
      if (key === 'sexualInterestCouple' || key === 'sexualInterestSingle') {
        merge = uniqBy([...userInfo[key], ...data], (v: any) => [v.id, v.listId].join());
        sortList = sortBy(merge, ['id']);
        sort = sortBy(merge, ['listId']);
      } else {
        merge = unionBy(userInfo[key], data, 'id');
        sort = sortBy(merge, ['id']);
      }

      return state.setIn([key], sort);
    }
    case types.PATCH_UPDATE_USER_PHOTO_SUCCESS: {
      const { galleryId, move, photoId, image, currentGalleryId } = action;
      let userPhoto = state.userPhoto.asMutable({ deep: true });
      const galleryID = galleryId.toString();
      // const galleryID = image.mainPhoto ? 'mainPhoto' : galleryId.toString();
      const galleryIndex = findIndex(userPhoto, (item: any) => item.id === galleryID);
      const galleryMainPhotoIndex = findIndex(userPhoto, (item: any) => item.id === 'mainPhoto');
      const galleryData = userPhoto[galleryIndex].data || [];

      if (galleryId === currentGalleryId && !move) {
        const patch = filter(galleryData, (item: any) => item.photoId !== photoId[0]);
        state = state.setIn(['userPhoto', `${galleryIndex}`, 'data'], patch);
        if (image.mainPhoto) {
          state = state.setIn(['userPhoto', `${galleryMainPhotoIndex}`, 'data'], []);
        }
        return state;
      }
      const currentGalleryID = currentGalleryId.toString();
      // const currentGalleryID = image.mainPhoto ? 'mainPhoto' : currentGalleryId.toString();
      const currentGalleryIndex = findIndex(userPhoto, (item: any) => item.id === currentGalleryID);
      const currentGalleryData = userPhoto[currentGalleryIndex].data;
      const patchDelete: any = filter(currentGalleryData, (item: any) => item.photoId !== photoId[0]);
      const patchMove: any = concat(galleryData, image);
      const updateObject = {
        userPhoto: [
          (userPhoto[galleryIndex] = {
            ...userPhoto[galleryIndex],
            data: patchMove,
          }),
          (userPhoto[currentGalleryIndex] = {
            ...userPhoto[currentGalleryIndex],
            data: patchDelete,
          }),
        ],
      };
      if (image.mainPhoto) {
        updateObject.userPhoto[galleryMainPhotoIndex].data = [];
      }
      const update = unionBy(updateObject.userPhoto, userPhoto, 'id');

      return state.merge({ userPhoto: update });
    }
    case types.UPLOAD_PHOTO_SUCCESS: {
      const { galleryId, photo } = action;
      const { userPhoto } = state;
      const galleryID = galleryId.toString();
      const galleryIndex = findIndex(userPhoto, (item: any) => item.id === galleryID);
      const galleryData = userPhoto[galleryIndex].data;
      const patch = concat(galleryData, photo);
      return state.setIn(['userPhoto', `${galleryIndex}`, 'data'], patch);
    }
    case types.GET_LIST_ENTITIES_SUCCESS: {
      const { categoryId, data } = action;
      let updateObject = {};
      if (categoryId === CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
        updateObject = {
          memberType: {
            contentTabs: [
              {
                data: data.items,
              },
            ],
          },
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.TU1_LOAD_SEX_SUCCESS: {
      const { data } = action;
      let updateObject: any = {};
      let memberTypeLabel = '';
      let gender: any[] = [];
      if (data.init?.memberType) {
        data.items.forEach((item: any) => {
          if (item.id !== 0) {
            if (item.id === data.init.memberType) {
              memberTypeLabel = item.label;
            }
            gender.push({
              ...item,
              active: item.id === data.init.memberType,
              value: 3,
            });
          }
        });
      }
      updateObject = {
        gender: gender,
      };
      if (memberTypeLabel) {
        updateObject.memberTypeLabel = memberTypeLabel;
      }
      return state.merge({ ...updateObject });
    }
    case types.SET_LOADED_ALL_GENERAL_DETAILS_SUCCESS: {
      return state.set('isLoadedFullGeneralDetail', true);
    }

    case types.RESET_STATUS_LOADED_PHOTO_AND_DATA: {
      return state.set('isLoadedFullGeneralDetail', false).set('isLoadedUserPhotos', false).set('isLoadedGaleries', false);
    }

    case types.UPDATE_EDIT_PROFILE_STATE: {
      return state.merge({ ...action.params });
    }

    case types.GET_USER_PROFILE_PHOTO_SUCCESS: {
      const { data } = action;
      return state.merge({ profilePhotos: data });
    }

    case types.UPDATE_STATE_EDIT_PROFILE_WITH_KEY: {
      return state.setIn([...action.dataKey], action.data);
    }

    default:
      return state;
  }
}
